// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8b1c483","453":"fdf0de24","455":"05043459","977":"26a7e0c3"}[chunkId] + ".chunk.js";
};